import { useMemo } from 'react';

// Single pass: Froala emits inline `color:` on spans/divs (#fff, rgb(255,255,255), etc.)
const WHITE_TEXT_COLOR_RE =
    /color\s*:\s*(?:#fff(?:fff)?\b|white\b|rgb\(\s*255\s*,\s*255\s*,\s*255\s*\)|rgba\(\s*255\s*,\s*255\s*,\s*255\s*(?:,\s*[\d.]+\s*)?\))/i;

const HAS_COLOR_DECL = /color\s*:/i;

export function htmlContainsWhiteTextColor(html) {
    if (!html || typeof html !== 'string') {
        return false;
    }
    if (!HAS_COLOR_DECL.test(html)) {
        return false;
    }
    return WHITE_TEXT_COLOR_RE.test(html);
}

export function useFroalaLightTextSurface(html) {
    return useMemo(
        () => htmlContainsWhiteTextColor(html || ''),
        [html]
    );
}
